"use client"
import { formatLocaleString } from "src/lib/locale/helpers";
import styles from "./ResetFilter.module.css";
import Button from "src/components/button/Button";
import { locale as loc } from "@locale";
import { useProgramFilterContext, useSelectedCinemaContext } from "src/lib/contexts/ContextTypes";
import type { RefObject } from "react";
import classNames from "classnames";

//#region [Props]
type ResetFilterProps = {
    numFilteredMovies?: number;
    numFilteredShows?: number;
    ref?: RefObject<HTMLElement | null>;
    className?: string;
};
//#endregion

//#region [Component]
export default function ResetFilter({ numFilteredMovies, numFilteredShows, ref, className }: ResetFilterProps) {
    const filterContext = useProgramFilterContext();
    const cinemaContext = useSelectedCinemaContext();
    return <div className={classNames(styles.SFilterInfo, className)}>
        <p>{formatLocaleString(loc.program.filterMessage.template, { numFilteredMovies: numFilteredMovies ? `${numFilteredMovies} ${loc.program.filterMessage.film}` : "", optionalShows: `${numFilteredMovies && numFilteredShows ? "og" : ""} ${numFilteredShows ? `${numFilteredShows} ${loc.program.filterMessage.shows}` : ""}` })}</p>
        {/* the counts include shows hidden by the cinema filter, so the cinemas are reset too */}
        <Button text={loc.program.filterMessage.reset} onClick={() => { filterContext.reset(); cinemaContext.resetSelectedCinemas(); ref?.current?.scrollIntoView({ behavior: "smooth" }) }} />
    </div>;
}
//#endregion